import NumberFlow from "@number-flow/react"
import { Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import { useAnimatedNumber } from "../../hooks/useAnimatedNumber"
import InfoTooltip from "../InfoTooltip/InfoTooltip"
import Private from "../Private"
import { formatKpiValue } from "./formatKpiValue"

import styles from "./kpiTabs.module.less"

const { Text } = Typography

// One dashboard KPI: label with its tooltip, the animated figure, a secondary line, and the
// same figure over the comparison window while a comparison is on (`tab.comparison`).
// `readOnly` draws it as a plain stat, without the click, underline and wash of a tab.
const KpiTab = ({ tab, active, onSelect, readOnly, className }) => {
  const { t } = useTranslation()
  const animatedValue = useAnimatedNumber(tab.value)
  const Root = readOnly ? "div" : "button"

  return (
    <Root
      {...(readOnly ? {} : { type: "button", onClick: () => onSelect(tab.key) })}
      className={cls(
        styles.tab,
        { [styles.active]: active, [styles.readOnly]: readOnly },
        className
      )}
    >
      {!readOnly && <span aria-hidden="true" className={styles.underline} />}
      <Flex gap={4} align="center">
        <Text className={styles.label} ellipsis={{ tooltip: tab.label }}>
          {tab.label}
        </Text>
        {tab.tooltip && <InfoTooltip title={t(tab.tooltip)} />}
      </Flex>
      <Text className={styles.value}>
        <Private>
          {tab.value == null ? (
            "-"
          ) : (
            <NumberFlow
              value={animatedValue}
              prefix={tab.prefix || ""}
              suffix={tab.suffix || ""}
              format={{ maximumFractionDigits: 0 }}
            />
          )}
        </Private>
      </Text>
      {tab.secondary ? (
        <Text className={styles.secondary}>
          {tab.secondaryPrivate ? <Private>{tab.secondary}</Private> : tab.secondary}
        </Text>
      ) : null}
      {tab.comparison != null ? (
        <Text type="secondary" className={styles.secondary}>
          {/* Money is always masked; a page that hides every figure sets `comparisonPrivate`. */}
          <Private disabled={!tab.prefix && !tab.comparisonPrivate}>
            {`${formatKpiValue(tab)(tab.comparison)} ${tab.comparisonLabel || t("previous period")}`}
          </Private>
        </Text>
      ) : null}
    </Root>
  )
}

export default KpiTab
